module.exports = __webpack_public_path__ + "img/tarj-motor-reservas.8d4dfc04.png";